// extracted by mini-css-extract-plugin
export var bubble = "_24-0";
export var container = "_24-f";
export var contrastBorder = "_24-g";
export var greyOut = "_24-2";
export var initialsColor0 = "_24-3";
export var initialsColor1 = "_24-4";
export var initialsColor10 = "_24-d";
export var initialsColor11 = "_24-e";
export var initialsColor2 = "_24-5";
export var initialsColor3 = "_24-6";
export var initialsColor4 = "_24-7";
export var initialsColor5 = "_24-8";
export var initialsColor6 = "_24-9";
export var initialsColor7 = "_24-a";
export var initialsColor8 = "_24-b";
export var initialsColor9 = "_24-c";
export var initialsWrapper = "_24-1";
export var large = "_24-l";
export var medium = "_24-k";
export var mediumSmall = "_24-j";
export var mediumSmallMedium = "_24-o";
export var micro = "_24-h";
export var small = "_24-i";
export var tiny = "_24-n";
export var xTiny = "_24-m";